import { render } from "./UserReportItem.vue?vue&type=template&id=6f6fc065&scoped=true"
import script from "./UserReportItem.vue?vue&type=script&lang=js"
export * from "./UserReportItem.vue?vue&type=script&lang=js"

import "./UserReportItem.vue?vue&type=style&index=0&id=6f6fc065&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6fc065"]])

export default __exports__